import React from 'react';
import './MainContent.css';
import Button from '../../Components/Button/Button';
import image from '../../Images/MainContent/Engine Cover.png'; // Replace with your image path

import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faStore } from '@fortawesome/free-solid-svg-icons';      // storefront
import textlogo from '../../Images/Logo/IceGemsText2.png'

interface clickObj {
  onClick: () => void;
}

const MainContent: React.FC<clickObj> = ({ onClick }) => {
  return (
    <div className='MainContent'>
      <div className='imageColumn'>
        <img className='mainImage' alt="Responsive" loading="lazy" src={image} />
      </div>
      <div className='textColumn'>
        <div className='textContent'>
          <img loading="lazy" src={textlogo} className='logoImage' />
          <p className='description'>
            Global Engine Efficiency Solutions
          </p>

        </div>
        <div className='buttonFormat'>

          <div className="button-grid">
            <div className="button-container">
              <Button name="scroll-button" text="" type="" wnum={200} onClick={onClick} iconPath={faYoutube} />
            </div>
            <div className="button-container">
              <Button name="ReqInfo" text="" type="" wnum={200} href='./request-info' iconPath={faPaperPlane} />
            </div>
            {/* <div className="button-container">
              <Button name="scroll-button" text="" type="" wnum={200} href='./news' iconPath={faStore} />
            </div> */}
            {/* 4th cell intentionally empty */}
          </div>
          {/* <div style={{ display: 'flex', gap: '3rem' }}>
            <Button name="scroll-button" text="" type="" wnum={200} onClick={onClick} iconPath={faYoutube} />
            <Button name="ReqInfo" text="" type="" wnum={200} href='./request-info' iconPath={faPaperPlane} />
          </div>

          <Button name="scroll-button" text="" type="" wnum={200} href='./request-info' iconPath={faStore} /> */}
        </div>
      </div>
    </div>
  );
};

export default MainContent;